import React, { useState } from 'react';
import axios from 'axios';
import { useConfirm } from './ConfirmDialog';
import { useToast } from './ToastContext';
import { FiMessageSquare, FiCheck } from 'react-icons/fi';
import './../Styles/Knowledge.css';

const apiUrl = process.env.REACT_APP_API_URL;

const OneToOneButton = ({
    employeeId,
    quarter,
    isRequested = false,
    isAcknowledged = false,
    isMainManager = false,
    isButtonEnabled = true,
    onRequested
}) => {
    const confirm = useConfirm();
    const showToast = useToast();
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Main Manager does not request a one-on-one discussion with themselves
    if (isMainManager) {
        return null;
    }

    const handleClick = async () => {
        if (!isButtonEnabled || isRequested || isAcknowledged || isSubmitting) return;

        const ok = await confirm({
            title: 'Request One-on-One Discussion',
            message: 'Are you sure you want to request a one-on-one discussion with your Project Manager regarding your performance ratings?',
            confirmLabel: 'Confirm Request',
            cancelLabel: 'Cancel',
            variant: 'primary'
        });

        if (!ok) return;

        setIsSubmitting(true);
        try {
            const response = await axios.post(`${apiUrl}/api/request-one-to-one`, {
                employeeId,
                quarter
            });

            showToast(
                response.data?.message || 'Your one-on-one discussion request has been successfully sent to your Project Manager.',
                'success'
            );

            if (onRequested) {
                onRequested(quarter);
            }
        } catch (error) {
            console.error('Error sending one-on-one discussion request:', error);
            const errorMsg = error.response?.data?.error || 'Failed to send one-on-one discussion request. Please try again.';
            showToast(errorMsg, 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    const isDisabled = !isButtonEnabled || isRequested || isAcknowledged || isSubmitting;

    return (
        <div className="onetoone-container">
            <button
                type="button"
                className="onetoone-button"
                onClick={handleClick}
                disabled={isDisabled}
                style={{
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    backgroundColor: !isButtonEnabled || isSubmitting || isAcknowledged ? '#d3d3d3' : (isRequested ? '#ffc107' : ''),
                    color: !isButtonEnabled || isSubmitting || isAcknowledged ? '#888' : (isRequested ? '#333' : '')
                }}
                title={
                    isAcknowledged
                        ? 'Review has already been acknowledged'
                        : isRequested
                        ? 'One-on-One discussion has already been requested for this quarter'
                        : !isButtonEnabled
                        ? 'Discussion request will be enabled once ratings are available'
                        : 'Request a one-on-one discussion with your Project Manager'
                }
            >
                {isRequested ? (
                    <>
                        <FiCheck size={15} style={{ marginRight: '6px', verticalAlign: '-2px' }} />
                        One-on-One Requested
                    </>
                ) : isSubmitting ? (
                    'Sending...'
                ) : (
                    <>
                        <FiMessageSquare size={14} style={{ marginRight: '6px', verticalAlign: '-2px' }} />
                        One-on-One
                    </>
                )}
            </button>
        </div>
    );
};

export default OneToOneButton;
